<!-- 场所及设备情况表 -->

<template>
  <div class="tabCage table7E">
    <div class="tabTtl">
      <span>表 1-7：受处罚情况表</span>
      <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
				 <el-option
						 v-for="item in options"
						 :key="item.id"
						 :label="item.value"
						 :value="item.id">
					 </el-option>
				 </el-select> -->
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules" class="editBox">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td class="edName">是否有处罚情况：</td>
            <td class="edInp">
              <el-select v-model="params.isPunishment" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">具体情况：</td>
            <td class="edInpTextArea">
              <el-input :rows="5" type="textarea" disabled v-model="params.punishment" size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="tipsLine">
              <div class="tips">
                注：
                填写2023年和2024年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。
              </div>
            </td>
          </tr>
        </table>
        <table :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
          <tr>
            <td class="edName">是否有处罚情况：</td>
            <td class="edInp">
              <el-select
                v-model="historyJsonParams.isPunishment"
                disabled
                size="small"
                placeholder="请选择"
                :class="historyJsonParams.isPunishment !== params.isPunishment ? 'highlight' : ''">
                <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">具体情况：</td>
            <td class="edInp">
              <el-input
                :rows="5"
                type="textarea"
                disabled
                v-model="historyJsonParams.punishment"
                size="small"
                :class="historyJsonParams.punishment !== params.punishment ? 'highlight' : ''">
              </el-input>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="tipsLine">
              <div class="tips">
                注：
                填写2021年和2022年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。
              </div>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea newEditArea" :class="value !== '' ? 'newStyle' : ''">
        <div class="editBox">
          <p class="edName">申报人：</p>
          <div class="edInp">
            <el-input disabled size="small" v-model="declare.personnel"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">联系方式：</p>
          <div class="edInp">
            <el-input disabled size="small" v-model="declare.contact"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">申报时间：</p>
          <div class="edInp">
            <el-input disabled size="small" v-model="updatedAt"></el-input>
          </div>
        </div>
      </div>
      <div class="editArea newEditArea" :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
        <div class="editBox">
          <p class="edName">申报人：</p>
          <div class="edInp">
            <el-input
              disabled
              size="small"
              v-model="historyDeclare.personnel"
              :class="historyDeclare.personnel !== declare.personnel ? 'highlight' : ''">
            </el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">联系方式：</p>
          <div class="edInp">
            <el-input
              disabled
              size="small"
              v-model="historyDeclare.contact"
              :class="historyDeclare.contact !== declare.contact ? 'highlight' : ''">
            </el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">申报时间：</p>
          <div class="edInp">
            <el-input
              disabled
              size="small"
              v-model="historyDeclare.updatedAt"
              :class="historyDeclare.updatedAt !== updatedAt ? 'highlight' : ''">
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { tabUpdate7, tabRead7, pSubmitHistoryList } from "@/api/pressRole/pressRole";
import { getFileToken } from "@/api/account";
export default {
  data() {
    return {
      params: {
        isPunishment: "",
        punishment: "",
        id: "",
        publishId: "",
        publishMaterialId: "",
      },
      rules: {
        isPunishment: [{ required: true, message: "请选择", trigger: "change" }],
        punishment: [
          { required: true, message: "不能为空！", trigger: "blur" },
          { max: 127, message: "填写内容过长！", trigger: "change" },
        ],
      },
      dicDats: {},
      submiting: false,
      value: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: "",
      },
      updatedAt: "",
      historyJsonParams: [],
      historyJson: [],
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: "",
      },
      options: [],
      value: "",
    };
  },
  methods: {
    editSave: function (name) {
      this.$refs[name].validate((valid) => {
        this.params.publishId = this.$route.query.pressId;
        this.params.publishMaterialId = this.$route.query.mtId;
        if (valid) {
          tabUpdate7({ ppunishment: this.params })
            .then((response) => {
              this.submiting = false;
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              this.$router.push({
                path: "audio_press",
                query: {
                  pressType: this.$route.query.pressType,
                },
              });
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function () {
      tabRead7({ id: this.$route.query.mtId }).then((response) => {
        this.params = response.ppunishment;
        if (response.pOrganizationPersonnel !== null) {
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    dictInit: function () {
      let nameArr = ["C018"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then((result) => {
        this.dicDats = result;
      });
    },

    goBack: function () {
      this.$router.go(-1);
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function () {
      let that = this;
      pSubmitHistoryList({ publishMaterialId: this.$route.query.mtId }).then((response) => {
        that.historyJson = response.pSubmitHistoryList;
        for (const list of response.pSubmitHistoryList) {
          that.options.push({ value: list.createdAt, id: list.id });
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function (id) {
      const that = this;
      for (const list of that.historyJson) {
        if (id == list.id) {
          that.historyJsonParams = JSON.parse(list.afterJson);
          that.historyDeclare = JSON.parse(list.submittor);
        }
      }
      // 获取图片
      getFileToken().then((data) => {
        that.historyImgUrl =
          process.env.BASE_API +
          "/File/File/download/token/" +
          data.resultStatus.token +
          "/id/" +
          that.historyJsonParams.yyzzId;
      });
    },
  },

  mounted() {
    this.getHistoryList();
  },
  created: function () {
    this.dictInit();
    this.tabReEdit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table7E .edInp .el-textarea {
  width: 450px;
}

.table7E .tipsLine .tips {
  font-size: 12px;
  color: #999999;
  padding: 0px 12px;
  width: 480px;
}

.table7E {
  .editBox {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .highlight {
    .el-input__inner,
    .el-textarea__inner {
      color: red !important;
    }
  }

  .selectTime {
    float: right;
    font-weight: normal;
  }

  .newStyle {
    margin: 30px 0 !important;
    width: 50% !important;
    overflow: hidden;
    float: left;
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table7.vue?9a38b09a